import { Controller } from "@hotwired/stimulus";

/**
 * mypage-listing-car-prices-edit
 */
export default class extends Controller {
  static targets = [
    "price",
    "systemUseFee",
    "transferAmount",
    "releaseOwnership",
    "releaseOwnershipFee",
    "fixedReleaseDate",
    "modal",
  ];

  connect() {
    this.updateSystemUseFee();
  }

  validateInputValue(e) {
    const inputedPrice =
      (e.target.value >= 0 && parseInt(e.target.value, 10)) || 0;
    e.target.value = inputedPrice;
  }

  checkInspectionExpiry() {
    const selectedValue = this.fixedReleaseDateTarget.value;
    const expirationDateStr = this.element.dataset.expiredCarInspectionDate;

    if (!selectedValue || !expirationDateStr) return;

    // 「即時（当月）」が選ばれた場合は、当月末日を基準に車検満了日と比較する
    const comparisonDate =
      selectedValue === this.element.dataset.immediateSelectValue
        ? this.element.dataset.immediateComparisonDate
        : selectedValue;

    if (comparisonDate >= expirationDateStr) {
      $(this.modalTarget).modal("show");
    }
  }

  updateSystemUseFee() {
    const inputedPrice = parseInt(this.priceTarget.value, 10) || 0;
    const price = inputedPrice * 10000;
    let systemUseFee = 0;
    let transferAmount = 0;

    // 初期値は事務局で設定した所有権解除費用
    // 事務局で確定していない場合は、後続の処理で可変する
    let releaseOwnershipFee = parseInt(
      this.element.dataset.commitReleaseOwnershipFee,
      10,
    );

    // 所有権解除費用の有無を算出する
    if (this.releaseOwnershipTargets.length > 0) {
      const releaseOwnership = this.releaseOwnershipTargets.find(
        (x) => x.checked,
      )?.value;
      if (releaseOwnership != "unnecessary") {
        releaseOwnershipFee = parseInt(
          this.releaseOwnershipFeeTarget.dataset.price,
          10,
        );
      }
    }

    // 最低出品価格 (ExhibitedCar::MINIMUM_PRICE) を下回る場合は計算しない。
    const minimumPrice = parseInt(this.element.dataset.minimumPrice, 10);
    if (price >= minimumPrice) {
      systemUseFee = this.#getSystemUseFee(price);
      transferAmount = price - systemUseFee - releaseOwnershipFee;
    }

    this.systemUseFeeTarget.textContent = systemUseFee.toLocaleString();
    this.transferAmountTarget.textContent = transferAmount.toLocaleString();
    this.releaseOwnershipFeeTarget.textContent =
      releaseOwnershipFee.toLocaleString();
  }

  // ExhibitedCar#seller_system_use_fee と同じ計算式。
  // 料率はサーバ側 (SystemUseFee.seller_fee_rate_percentage) が解決した値を受け取るため、
  // 手数料バージョンと料率の対応表をこちらに持たない。
  #getSystemUseFee(price) {
    const percentage = parseInt(this.element.dataset.sellerFeePercentage, 10);

    return Math.floor((Math.max(price, 1000000) * percentage) / 100);
  }
}
